module.exports = __webpack_public_path__ + "img/pen.65e11ddc.png";